import request from "@/utils/Request";
import {SubscriptionEndpoints} from "@/services/subscription/endpoints";


const getPaymentStatus = async () => {
  const response = await request.authorizedAxios().get(`${SubscriptionEndpoints.PAYMENT_STATUS_URI}`);
  return response;
}


const SubscriptionService = {
  getPaymentStatus,
}
export default SubscriptionService;
